import styled from '@emotion/styled'
import React from 'react'

const Wrapper = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  z-index: 1;
  border-radius: 50%;
  background-color: #3ec7b3;
  box-shadow: 0 0 20px #3ec7b3;
  &:before,
  &:after {
    content: '';
    display: block;
    position: absolute;
    margin: auto;
    width: 100%;
    height: 100%;
    border: 1px solid #3ec7b3;
    border-radius: 50%;
    box-sizing: border-box;
    pointer-events: none;
    animation: pulsate 3s linear infinite;
  }
  &:after {
    animation-delay: 1.5s;
  }
  @keyframes pulsate {
    0% {
      transform: scale(1);
      opacity: 1;
    }

    100% {
      transform: scale(2.5);
      opacity: 0;
    }
  }
`

type Props = {
  /** クラス名 */
  className?: string
}

/**
 * 波紋アニメーション
 * @constructor
 */

const AnimPulse = (props: Props): JSX.Element => {
  const { className = '' } = props

  return <Wrapper className={className} />
}

export default AnimPulse
